import React from 'react';
import { Row, Col, Button, Modal, Checkbox, notification } from 'antd';
import { ReloadOutlined, CheckSquareOutlined, CheckOutlined } from '@ant-design/icons';

const AdditionalColModal = ({
  setModal2Visible,
  isModal2Visible,
  tempCheckedList,
  setTempCheckedList,
  options,
  checkedList,
  setCheckedList,
  ADDITIONAL_COL,
}) => {
  const handleCheckAll = () => {
    const allValues = options.map(option => option.value);
    setTempCheckedList(allValues);
  };

  const handleOk_2 = () => {
    const addedColumns = tempCheckedList.filter(item => !checkedList.includes(item));
    const removedColumns = checkedList.filter(item => !tempCheckedList.includes(item));
    setCheckedList(tempCheckedList);
    setModal2Visible(false);

    if (addedColumns.length > 0) {
      const addedColumnNames = ADDITIONAL_COL.filter(col => addedColumns.includes(col.key))
        .map(col => col.value)
        .join(', ');

      notification.success({
        message: `Successfully added column${addedColumns.length > 1 ? 's' : ''}: ${addedColumnNames}`,
        duration: 2,
      });
    } else if (removedColumns.length > 0) {
      notification.info({
        message: 'Column selection updated.',
        duration: 2,
      });
    } else {
      notification.info({
        message: 'No changes were made.',
        duration: 2,
      });
    }
  };
  const handleCancel_2 = () => {
    setModal2Visible(false);
  };
  const handleReset_2 = () => {
    setTempCheckedList([]);
    notification['info']({
      message: `Column selection reset successfully!`,
      duration: 2,
    });
  };

  return (
    <>
      <Modal
        title="Choose Columns to Show"
        open={isModal2Visible}
        width={900}
        onCancel={handleCancel_2}
        footer={[
          <Button key="cancel" danger onClick={handleReset_2} icon={<ReloadOutlined />}>
            Reset
          </Button>,
          <Button key="checkall" type="primary" onClick={handleCheckAll} icon={<CheckSquareOutlined />}>
            Check All
          </Button>,
          <Button key="ok" type="primary" icon={<CheckOutlined />} onClick={handleOk_2}>
            Apply
          </Button>,
        ]}
      >
        <Checkbox.Group value={tempCheckedList} onChange={setTempCheckedList} style={{ width: '100%' }}>
          <Row gutter={[16, 8]}>
            {options.map((option, index) => (
              <Col key={option.value} xs={24} sm={12} md={8}>
                <Checkbox value={option.value}>{option.label}</Checkbox>
              </Col>
            ))}
          </Row>
        </Checkbox.Group>
      </Modal>
    </>
  );
};
export default AdditionalColModal;
